import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var appLayoutComponentName = 'QuantumAppLayout';
export function getAppLayoutUtilityClass(slot) {
    return generateUtilityClass(appLayoutComponentName, slot);
}
export var appLayoutClasses = generateUtilityClasses(appLayoutComponentName, [
    'root',
    'main',
    'container',
    'content',
]);
